import type { FullAuditEntry } from '@/lib/types'

interface AuditDetailRowProps {
  entry: FullAuditEntry
}

export function AuditDetailRow({ entry }: AuditDetailRowProps): React.JSX.Element {
  return (
    <div className="rounded-lg bg-surface-1 p-4">
      <p className="mb-2 text-xs font-medium uppercase text-text-secondary">Full Details</p>
      {entry.details ? (
        <pre className="overflow-x-auto whitespace-pre-wrap font-mono text-xs text-text-primary">
          {JSON.stringify(entry.details, null, 2)}
        </pre>
      ) : (
        <p className="text-sm italic text-text-tertiary">No additional details</p>
      )}
      {entry.ip_address && (
        <p className="mt-2 text-xs text-text-tertiary">IP: {entry.ip_address}</p>
      )}
    </div>
  )
}
